import React, { useState, useEffect } from "react";
import { withRouter, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation";
import { API, Auth } from "aws-amplify";
import "./App.css";
import "mapbox-gl/dist/mapbox-gl.css";
import Routes from "./Routes";
import AdminHeader from "./components/AdminHeader";
import Footer from "./components/Footer";

import { useSnackbar } from 'notistack';


function App(props) {

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const location = useLocation();
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [vendorID, setVendorID] = useState('');
  const [vendorMeta, setVendorMeta] = useState({});
  const [isLoading, setIsLoading] = useState(false)

  async function setVendorByName(name) {
    await loadVendors().then(response => {
      const result = response.data.find(item => item.alias == name);
      if (result) {
        setVendorID(result.vendor_id);
      }
    });
  }

  async function loadVendors() {
    let init = {
      headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    }
    return API.post("API", "/Vendors", init);
  }

  // Run on first load
  useEffect(() => {
    onLoad();
  }, [isAuthenticated]);

  // Run when vendorID changes
  useEffect(() => {
    console.log('VendorID skiftet til: ' + vendorID)
    //refresh current user meta
    if (vendorID !== '') {
      getVendorValues(vendorID)
        .then(response => {
          setVendorMeta(response.data)
        })
        .catch(response => enqueueSnackbar('Kunne ikke gemme profil: ' + response, { variant: 'error', }))
    } else {
      // ryd meta
      setVendorMeta({})
    }

  }, [vendorID])

  async function onLoad() {
    setIsAuthenticating(true)
    await Auth.currentSession()
      .then(response => {
        storeUserParams()
        userHasAuthenticated(true)
      })
      .catch(e => {
        if (e !== 'No current user') {
          alert(e);
        }
      })
      .finally(reponse => {
        setIsAuthenticating(false)
      });
  }

  async function getVendorValues(id) {
    let init = {
      headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    }
    return await API.post("API", "/Vendor/" + id, init);
  }

  async function storeUserParams() {
    Auth.currentAuthenticatedUser({
      bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    })
      .then(
        user => {
          if (user.attributes["custom:admin"] === '1' && user.attributes["custom:vendor_id"] === 'admin') {
            setIsAdmin(true);
            setVendorID('')
          } else {
            setIsAdmin(false);
            setVendorID(user.attributes["custom:vendor_id"])
          }
        }
      )
      .catch(
        err =>
          enqueueSnackbar('Kunne ikke hente bruger: ' + err, { variant: 'error', })
      );
  }

  async function handleLogout() {
    // sign out from AWS
    await Auth.signOut();

    // set state
    setIsAdmin(false);
    setVendorID('');
    userHasAuthenticated(false);

    //clear storage
    localStorage.clear();

    //move user to login
    props.history.push("/login");
  }

  return (
    !isAuthenticating &&
    <>
      {isAuthenticated && <Navigation appProps={{ isAdmin, vendorMeta, handleLogout }} />}
      <main>
        {isAdmin && !location.pathname.startsWith('/anmodning/') && <AdminHeader appProps={{ setVendorID, isLoading, vendorID }}  />}
        <Routes appProps={{ isAuthenticated, userHasAuthenticated, isAdmin, vendorID, setVendorID, setVendorByName, vendorMeta }} />
        {!isAdmin && <Footer />}
      </main>
    </>
  );
}

export default withRouter(App);